import { Controller } from "@hotwired/stimulus"
import "fslightbox"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    // Instantiate a new FsLightbox object specific to this controller
    this.lightbox = new FsLightbox()

    // Map the hrefs from our targets into the lightbox sources
    this.lightbox.props.sources = this.itemTargets.map(element => element.href)
  }

  open(event) {
    event.preventDefault()

    // Find the index of the clicked element to open the gallery at the right image
    const index = this.itemTargets.indexOf(event.currentTarget)

    // Open the lightbox at that index
    this.lightbox.open(index)
  }
}
